import React, { useEffect, useState } from 'react';
import { FormComponent, Notifications } from '../../../../../shared';
import { warehouseApi } from '../../../../../api/warehouse';
import { Typography, Box, Paper } from '@material-ui/core';

const UpdatePartnerLotAction = ({ lotId, partnerLotNumber, onSuccess }) => {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!(onSuccess instanceof Function)) {
            console.error('UpdatePartnerLotAction initialized incorrectly onSuccess is not a function');
        }
    }, [onSuccess]);

    const formFields = [
        {
            name: 'partnerLotNumber',
            label: 'Partner Lot Number',
            inputProps: { required: true },
            gridValue: 12,
        },
    ];

    const handleSubmit = async (formData) => {
        setLoading(true);
        const result = await warehouseApi.updateLot(lotId, {
            partnerLotNumber: formData.partnerLotNumber,
        });
        setLoading(false);

        if (!result.status) {
            setNotification({ text: result.msg, level: 'error' });
        } else {
            if (onSuccess instanceof Function) {
                onSuccess();
            }
        }
    };

    return (
        <Box>
            <Notifications options={notification} />

            <Paper elevation={0} style={{ padding: '16px', margin: '16px 0px', backgroundColor: '#f5f5f5' }}>
                <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    Current Partner Lot Number
                </Typography>
                <Typography variant="h6">{partnerLotNumber || 'Not Set'}</Typography>
            </Paper>

            <Box mt={2}>
                <FormComponent
                    formFields={formFields}
                    onSubmit={handleSubmit}
                    loading={loading}
                    button={{ text: 'Update Partner Lot' }}
                />
            </Box>
        </Box>
    );
};

export { UpdatePartnerLotAction };
